import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { PageSkeleton } from '@app/components/various/SkeletonLayout/layouts/PageSkeleton';
import { Wrapper, WrapperSize } from '@app/components/various/Wrapper';
import { Cms } from '@typings';

import { Section } from '../section';

import styles from './page.module.scss';

interface Props {
  sections: Cms.SectionDTO[];
  isLoading: boolean;
}

export const PageSections = ({ sections, isLoading }: Props) => {
  return (
    <Wrapper size={WrapperSize.XLARGE} className={styles.page}>
      <SkeletonLayout isLoading={isLoading} skeleton={<PageSkeleton />}>
        {sections.map(section => (
          <Section sectionData={section} key={section.id} />
        ))}
      </SkeletonLayout>
    </Wrapper>
  );
};
